/**
 * Pulls the first model out of a GraphQL query which has a data
 * array result.
 */
export function getSingleGraphQLModel<T>(result: { data?: T[] | null } | undefined) {
  return result?.data?.[0] ?? null;
}
